<div class="survey">
    <fa-icon
      class="survey__close mb-2"
      [icon]="['fas', 'times']"
      size="lg"
      title="close"
      (click)="closeDialog()">
    </fa-icon>

    <iframe [src]="src" class="survey__frame"></iframe>
</div>
